import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/Documentary.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import DocumentaryCard from './DocumentaryCard';
import { useVideosByCategory } from '../../hooks/useVideosHooks';

const KidStoriesSection = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (e) => {
    e.preventDefault();
    navigate('/video/category/Kid');
  };
  
  const { videos, isLoading, error } = useVideosByCategory('Kid', 1, 10);

  // Hide the section if there are no videos
  return (videos && videos.length > 0) || isLoading || error ? (
    <div className={styles.documentarySection}>
      <div className={styles.sectionHeader}>
        <h2>Kids Stories</h2>
        <a href="/DocumentaryFullPage" className={styles.viewAll} onClick={handleNavigation}>
          View all &gt;
        </a>
      </div>

      {isLoading ? (
        <div className={styles.loadingState}>Loading documentaries...</div>
      ) : error ? (
        <div className={styles.errorState}>Error loading documentaries: {error.message}</div>
      ) : (
        <div className={styles.cardContainer}>
          <Swiper
            modules={[Navigation, Mousewheel]}
            navigation
            mousewheel={{ forceToAxis: true, invert: false, sensitivity: 1 }}
            spaceBetween={20}
            slidesPerView="auto"
            className={styles.swiper}
            breakpoints={{
              320: { slidesPerView: 1.5 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
              1440: { slidesPerView: 4 },
            }}
          >
            {videos.map((doc) => (
              <SwiperSlide key={doc.id}>
                <DocumentaryCard documentary={formatDocumentaryData(doc)} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  ) : null;
};

// Helper function to format API response data to match the expected format for DocumentaryCard
const formatDocumentaryData = (apiDoc) => ({
  id: apiDoc.id,
  title: apiDoc.title,
  slug: apiDoc.slug,
  description: apiDoc.description,
  computer_image_url: apiDoc.computer_image_url || '/fallback-image.jpg',
  mobile_image_url: apiDoc.mobile_image_url,
  author_name: apiDoc.author_name,
  duration: formatDuration(apiDoc.duration),
  category: apiDoc.category,
  video_url: apiDoc.video_url,
});

// Helper function to format duration from seconds to MM:SS
const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};


export default KidStoriesSection;
